export interface UserState {

  /** 當前申請人登錄信息 */
  profile: {
    euid: string;
    // 申请人姓（中文）
    applicantLastnameZh: string;
    // 申请人名（中文）
    applicantNameZh: string;
    // 申请人姓（外文）
    applicantLastnameFl: string;
    // 申请人名（中文）
    applicantNameFl: string;
    // 申請主體證件類型
    applicantCertType: number;
    applicantCertTypeDesc: string;
    // 申請主體證件號碼
    applicantCertNo: string;
    // 通知语言
    informLanguage: string;
    // 流动电话号码
    mobilePhone: string;
    // 接收讯息方式
    acceptInformType: string;
  };
}

export const userInitState = {
  profile: {},
};

export default {
  namespace: 'user',
  state: userInitState,

  reducers: {
    update: (state: UserState, payload: Partial<UserState>) => ({
      ...state,
      ...payload,
    }),
    init: () => userInitState,
  },
};
